import React from 'react';
import { ReactComponent as Dot } from './dot.svg';
import { isNumber } from 'lodash';
import { Theme } from '@mui/material';
import clsx from 'classnames';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        cursor: 'pointer'
    },
    disabled: {
        filter: 'grayscale(100%)',
        opacity: 0.5
    }
}))

type Props = {    
    width?: number,
    height?: number,
    size?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl',
    disabled?: boolean;
    style?: any;
    onClick?: () => void;
}

type InnerProps = Props & {
    SvgIcon: any
}

export function Icon({ SvgIcon, width, height, size, disabled, style, onClick}: InnerProps) {

    const classes = useStyles();

    if (size) {
        let dim: number;
        switch (size) {
            case 'xs':
                dim = 24; break;
            case 'sm':
                dim = 32; break;
            case 'md':
                dim = 48; break;
            case 'lg':
                dim = 64; break;
            case 'xl':
                dim = 96; break;
            default:
                dim = isNumber(size) ? size : 32;
        }

        width = dim;
        height = dim;
    }

    style = style || {};
    style= {
        ...style,
        width: width ?? 32,
        height: height ?? 32
    }

    return (
        <SvgIcon 
            style={style}
            className={clsx({
                [classes.root]: true,
                [classes.disabled]: disabled
            })}
            onClick={onClick}
        />
    );
}

export const Icons = {
    Document: (props?: Props) => <Icon {...props} SvgIcon={Document} />,
    Dot: (props?: Props) => <Icon {...props} SvgIcon={Dot} />,
}
